import nuxtStorage from 'nuxt-storage';
import hosts from '../data/hosts.json'
import { defineStore } from 'pinia'
export const languagesDefault = [
  { flag: 'es', language: 'es', title: 'Español' }
  // ,
  // { flag: 'en', language: 'en', title: 'English' },
  // { flag: 'ca', language: 'ca', title: 'Catalá' },
  // { flag: 'eu', language: 'eu', title: 'Euskera' },
  // { flag: 'fr', language: 'fr', title: 'French' },
  // { flag: 'de', language: 'de', title: 'Deutsch' },
  // { flag: 'nl', language: 'nl', title: 'Dutch' },
  // { flag: 'pl', language: 'pl', title: 'Polish' },
  // { flag: 'no', language: 'no', title: 'Norwegian' },
  // { flag: 'ro', language: 'ro', title: 'Romanian' }
]

export const useStore = defineStore('store', {
  state: () => ({
    api_url: "",
    host: "",
    TITULO: "",
    NOTARIA: null,
    loading: true,
    VIEWMODEL: {},
    ModoAccesible: false,
    token: null,
    user: null,
    idioma: "es",
    languages: null,
    css_list: null,
    RecaptchaGroups: [null, '6LcoRlklAAAAAE3SgHyos1jSBhRG-NvwKESOy3MT', '6Ld6r1QpAAAAAKECU6jo-xhLRHsnu_2ofmOS5v4W', '6Lep4lQpAAAAAP-mTLTamzilYsfiByuPs-Q1GsAj', '6Lcg41QpAAAAAMQ2wDYA9ryclG3RIYLcXHG6lu63','6LdRkr0rAAAAAKRmvtwZlA1_jFEQ2CA7CgelyG99'],
    recaptchaSiteKey: null,
    ARCHIVOS_COMUNES: [] as any[],
    isChatbotOpen: false,
    pendingChatQuery: "",
    chatbotOverQuota: false,
  }),
  getters: {
    backend_api_url: (state): string => {
      if (process.env.NODE_ENV === 'development') {
        const url = state.api_url || process.env.NUXT_ENV_API_URL || 'http://localhost:5001/'
        return url.endsWith('/') ? url : url + '/'
      }
      return 'https://controlpanel.notin.es/'
    }
  },
  actions: {
    async initNotaria(headers: any, route: any, apiUrl?: string) {
      try {
        if (headers && headers.host) {
          //console.log(new Date())
          console.log("initNotaria ");
          this.host = headers.host

          if (process.env.NODE_ENV === 'development') {
            this.api_url = apiUrl || process.env.NUXT_ENV_API_URL || 'http://localhost:5001/'
          } else {
            this.api_url = 'https://' + this.host + '/'
          }

          console.log('backend api_url: ' + this.api_url)
        }

        //Seleccionamos la notaría según el host
        var id = 23; //Notaría por defecto     
        hosts.map((h) => {
          if (h.hosts.includes(this.host)) {
            id = h.id;
          }
        });

        console.log('idNotaria: ' + id)
        await this.loadLanguages(id, route);
        await this.loadArchivosComunes(id);
        
        // El sufijo del archivo SIEMPRE depende de si es español o no (notaria.json es ES)
        var idiomaSuffix: string = this.idioma && this.idioma != "es" ? "_" + this.idioma : "";
        var dataurl = ""
        if (process.env.NODE_ENV === "development") {
          dataurl = this.api_url +
            "appdata/" +
            id +
            "/data/notaria" +
            idiomaSuffix +
            ".json?v=" +
            Date.now()
        } else {
          dataurl = this.api_url + "appdata/data/notaria" + idiomaSuffix + ".json?v=" + Date.now()
        }
        console.log("dataurl: " + dataurl)
        var res: any;
        try {
          if (this.NOTARIA) {
            if (this.NOTARIA.Languaje != this.idioma) {
              res = await $fetch(dataurl)
            } else {
              res = this.NOTARIA
            }
          } else {
            res = await $fetch(dataurl)
          }
        } catch (err) {
          console.warn("Could not load static JSON file, calling backend API to generate and retrieve:", err)
          try {
            var apiPath = this.api_url + "api/Notarias/" + id + (this.idioma && this.idioma !== "es" ? "/" + this.idioma : "")
            res = await $fetch(apiPath)
          } catch (apiErr) {
            console.error("Backend API fallback failed:", apiErr)
            // Último recurso: intentar cargar el notaria.json básico por si acaso
            if (idiomaSuffix !== "") {
              try {
                var fallbackUrl = process.env.NODE_ENV === "development" 
                  ? this.api_url + "appdata/" + id + "/data/notaria.json?v=" + Date.now()
                  : this.api_url + "appdata/data/notaria.json?v=" + Date.now();
                res = await $fetch(fallbackUrl)
              } catch (fallbackErr) {
                console.error("Static main fallback failed:", fallbackErr)
              }
            }
          }
        }

        if (res) {
          this.NOTARIA = res;
          this.TITULO = this.NOTARIA.Nombre;
          if (this.NOTARIA.Personalizar && this.NOTARIA.Personalizar.RecaptchaGroup) {
            this.recaptchaSiteKey = this.RecaptchaGroups[this.NOTARIA.Personalizar.RecaptchaGroup]
          }
        }
        await this.loadcssjs(id);
        
        await this.initLogin();

        //Se configura en el panel de control
        // await dispatch('getReviews')
      } catch (e) {
        console.error("Error in initNotaria:", e);
      } finally {
        this.loading = false;
      }

      return id
    },

    async FecthModoAccesible() {
      var r = eval(typeof window !== 'undefined' ? nuxtStorage.localStorage.getData("ModoAccesible") : false);
      this.ModoAccesible = r;
    },
    async toggleModoAccesible() {
      nuxtStorage.localStorage.setData("ModoAccesible", !this.ModoAccesible);
      this.ModoAccesible = !this.ModoAccesible;
    },
    async setIdioma(v: any) {
      this.idioma = v;
    },
    async initLogin() {
      const cookieToken = useCookie('nuxt-token').value;
      this.token = typeof window !== 'undefined' ? (nuxtStorage.localStorage.getData("token") || cookieToken) : cookieToken;
    },

    getReviews() {
      //console.log("Entra en getReviews");

      const url = `https://maps.googleapis.com/maps/api/place/details/json?placeid=ChIJw4xGRQiBYw0Rj66sxkqopA0&key=AIzaSyCzggys0LtiRm_d97j6ud0m2l6khuYzqq4`;

      useFetch(url)
        .then((response) => {
          // Procesa la respuesta para obtener las reseñas
          const reviews = response.data.result.reviews;
          //console.log(reviews);
        })
        .catch((error) => {
          console.error("Error al obtener las reseñas:", error);
          //console.log(error.response.data.error);
        });
    },
    async loadcssjs(id: any) {
      var timestamp = new Date().getTime();
      //inyectar css
      var url_css_dev = this.api_url + "appdata/" + id + "/static/";
      var url_css_prod = this.api_url + "appdata/static/";
      var url_css =
        process.env.NODE_ENV === "development" ? url_css_dev : url_css_prod;
      var css = [
        "header.css",
        //"home-banner.css",
        // "home-blog.css",
        // "home-pn.css",
        //"home-servicios.css",
        "home-testimonios.css",
        "blog.css",
        // "servicios.css",
        //"form.css",
        // "footer.css",
        "notarios.css",
        // "team.css",
        // "contacto.css",
        "gallery.css",
        //"home-gallery.css"
      ];
      var csslist: Array<string> = []
      if (this.NOTARIA.Personalizar.CustomCSS !== "") css.push("custom.css");


      css.forEach(c => {
        csslist.push(url_css + c + "?v=" + timestamp)
      })
      this.css_list = csslist

    },
    async loadLanguages(id: any, route: any) {
      console.log("loadLanguages")
      var langaugeUrl
      if (process.env.NODE_ENV === "development") {
        langaugeUrl = this.api_url +
          "appdata/" +
          id +
          "/data/idiomasNotaria.json?v=" +
          Date.now()
      } else {
        console.log(this.api_url);
        langaugeUrl = this.api_url + "appdata/data/idiomasNotaria.json?v=" + Date.now()

      }
      console.log(langaugeUrl)
      var res: any = await $fetch(langaugeUrl).catch(() => null)
      if (res) {
        this.languages = res.Idiomas
      } else {
        this.languages = languagesDefault
      }
      
      const firstInList = this.languages && this.languages.length > 0 ? this.languages[0].Language : 'es';
      
      // Si estamos en la raíz (sin idioma en URL)
      if(!route?.params?.lang){
        console.log('Detectada ruta raíz (/), seteando idioma principal configurado:', firstInList)
        this.setIdioma(firstInList)
      } else {
        // Si hay un idioma en la URL, verificamos que sea válido en la lista de la notaría
        if(this.languages.some(l => l.Language == route.params.lang)){
           this.setIdioma(route.params.lang)
        } else {
           this.setIdioma(firstInList) // Fallback si el idioma de la URL no es válido
        }
      }
    },

    async loadArchivosComunes(id: any) {
      try {
        var url = "";
        if (process.env.NODE_ENV === "development") {
          url = this.api_url + "appdata/" + id + "/data/archivos.json?v=" + Date.now();
        } else {
          url = this.api_url + "appdata/data/archivos.json?v=" + Date.now();
        }
        console.log("Cargando archivos comunes desde: " + url)
        const res: any = await $fetch(url);
        if (res) {
          this.ARCHIVOS_COMUNES = res;
        }
      } catch (e) {
        console.log("No se pudo cargar archivos.json, se usará el fallback por idioma.");
        this.ARCHIVOS_COMUNES = [];
      }
    },


    /**
     * Crea routas dinámicas según los idiomas disponibles
     */
    // CreateDynamicLanguagesRoutes() {
    //   console.log("CreateDynamicLanguagesRoutes")   
    //   const rutas = this.router.getRoutes()
    //   this.languages.forEach(lang => {
    //     if (lang.language != 'es') {
    //       rutas.forEach(ruta => {
    //         var r = { ...ruta }
    //         r.path = "/" + lang.Language + ruta.path
    //         r.name = lang.Language + '-' + ruta.name
    //         console.log('adding route ' + r.name + ' ' + r.path)
    //         this.router.addRoute(r)
    //       })
    //     }
    //   })
    // },


    /**
     * Realiza el login del usuario
     * @param userLogin Objeto con los datos de login {username,password}
     */

    async doLogin(userLogin: any) {
      var loginUrl = this.api_url + 'api/authentication'

      var result = await $fetch(loginUrl, { method: "POST", body: userLogin, headers: { 'Content-Type': 'application/json' } })
      if (result) {
        this.token = result;
        var tokenparsed = this.parseJwt(result)

        this.user = tokenparsed.user
        nuxtStorage.localStorage.setData('token', this.token);
        nuxtStorage.localStorage.setData('user', tokenparsed.user);
        
        const cookieToken = useCookie('nuxt-token', { maxAge: 60 * 60 * 24 * 7 }); // 7 días
        cookieToken.value = this.token;
        var user = JSON.parse(tokenparsed.user)
        var notariaIdStr = String(this.NOTARIA.id)
        var hasAccess = user.IsGlobalAdmin || (user.Notarias && user.Notarias.some((id: any) => String(id) === notariaIdStr))
        
        if (hasAccess)
          return true;
        else
          return false;
      } else {
        return false;
      }
    },
    async doLogOut() {
      this.token = null;
      this.user = null;
      nuxtStorage.localStorage.setData('token', null);
      nuxtStorage.localStorage.setData('user', null);
      const cookieToken = useCookie('nuxt-token');
      cookieToken.value = null;
    },
    parseJwt(token: string) {
      if (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
      } else {
        alert('Falló la autenticación, necesita un usuario');
      }
    }
  },
  getters: {
    getIdioma: (state) => {
      const store = useStore()
      return store.idioma
    },
    getFlag: (state) => {
      const store = useStore()
      var lang = store.languages ? store.languages.find((x: any) => x.Language === store.idioma) : null
      return lang ? lang.Flag : "es"
    }
  }
})
